import { Component } from "react";
import { connect } from "react-redux";
import UserTableItem from "./userTableItem";
class UsersTable extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.TableHeaderText = ["#", "الإسم", "البريد الالكتروني ", "الوظيفة", "-"];
  }
  render() {
    // const data = [
    //   {
    //     full_name: "Guettaf ",
    //     email: "gtf@gmail.com",
    //     user: "Manager",
    //     uuid: "afba551e-507a-461a-a9cd-57a6b26bd924",
    //     account_status: "Activated",
    //   },
    // ];
    const { data } = this.props;
    return (
      <div>
        <table className="table mt-3 align-middle">
          <thead>
            <tr className="text-center" style={{ fontSize: "12px" }}>
              {this.TableHeaderText.map((txt, idx) => (
                <th scope="col" key={"usersTable-th" + idx}>
                  {txt}
                </th>
              ))}
            </tr>
          </thead>
          <tbody class="table-group-divider">
            {this.props.isLoading ? (
              <tr>
                <td colSpan={6} className="text-center">
                  <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : (
              data.map((obj, idx) => (
                <UserTableItem obj={obj} userOrder={idx + 1} />
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({ data: state.UsersState.users });
export default connect(mapStateToProps, mapDispatchToProps)(UsersTable);
